import * as React from "react";
import { Button, Row, Col } from "reactstrap";

import { connect } from "react-redux";
import Slider, { createSliderWithTooltip } from "rc-slider";
import "../../style/slider.scss";
import {
  ApplicationAction,
  setAmount,
  setRepaymentPeriod,
  gotoStep
} from "../../store/application/applicationActions";
import { RootState } from "../../store";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import LoanDetails from "./LoanDetails";
import { Step } from "../../store/application/applicationState";
import { StringUtil } from "../../util/stringUtil";
import ApplicationHeader from "../applicationHeader";
import { trackEvent } from "../../util/gtm";
import { calculateMonthlyPaymentAmount } from "../../util/calculator";



const SliderWithTooltip = createSliderWithTooltip(Slider);

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;
interface State {
    options: {period:number }[];
}
class StepTwo extends React.Component<Props,State > {
  constructor(props: any) {
      super(props);
      if (this.props.application.data.loanAmount < 50000) {
          this.state = {
              options: [
                  {
                      period: 72
                  },
                  {
                      period: 48
                  },
                  {
                      period: 36
                  },
                  {
                      period: 24
                  },
              ]
          };
      }
      else if (this.props.application.data.loanAmount == 50000) {
          this.state = {
              options: [
                  {
                      period: 72
                  },
                  {
                      period: 60
                  },
                  {
                      period: 48
                  },
                  {
                      period: 36
                  },
              ]
          };
      }
      else if (this.props.application.data.loanAmount == 75000) {
          this.state = {
              options: [
                  {
                      period: 96
                  },
                  {
                      period: 72
                  },
                  {
                      period: 60
                  },
                  {
                      period: 48
                  },
              ]
          };
      }
      else if (this.props.application.data.loanAmount == 100000) {
          this.state = {
              options: [
                  {
                      period: 108
                  },
                  {
                      period: 84
                  },
                  {
                      period: 72
                  },
                  {
                      period: 60
                  },
              ]
          };
      }
      else if (this.props.application.data.loanAmount == 150000) {
          this.state = {
              options: [
                  {
                      period: 120
                  },
                  {
                      period: 96
                  },
                  {
                      period: 84
                  },
                  {
                      period: 72
                  },
              ]
          };
      }
      
    }


  

    amountFormatter(value: number, period: number): string {
        let result = value/period
        return StringUtil.numberWithCommas(result) + " kr.";
  }

  monthFormatter(value: number): string {
      return value + " mdr.";
    }



    render() {
        var params = window.location.search.toString().toString();
        var mark;
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            console.log(params)
            if (params.includes("step")) {
                params = params.replace(regex, "$1" + this.props.application.currentStep);

            }
            else {
                mark = "&step=" + this.props.application.currentStep;

            }
        }
        else {
            mark = "?step=" + this.props.application.currentStep;
        };

        if (mark == undefined)
            mark = "";
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params + mark;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
    var btnSize = {
      width: "115px",
      height: "50px"
    };

      return (
    
      <div>
 
              <ApplicationContent>
                <div className="package-holder">
                <h2 className="mb-2">Vælg pakke</h2>
                <h4 className="mb-2 text-center stepTwoAmount d-none d-md-block">Dit valgte lånebeløb: {StringUtil.numberWithCommas(this.props.application.data.loanAmount)} kr.</h4>
                <h4 className="mb-2 text-center stepTwoAmount d-md-none">Lånebeløb: {StringUtil.numberWithCommas(this.props.application.data.loanAmount)} kr.</h4>
                <div className="row">
                   
                    <div className=" col-6 col-sm-6 py-2 px-2  col">
                        <div className="contrast-badge-popular">
                            <div>Mest populære</div>
                        </div>
                    </div>
                   
                
                </div>
                      <div className="row justify-content-center ">
                        
                    {this.state.options.map((options, index) => (
                        <Col
                            key={index}
                            className={
                                "col-6 col-sm-6 py-2 px-2 " + "col-amount-" + options.period
                            }
                        >
                            <Button
                                className="package-btn"
                                onClick={() => {
                                    this.props.setRepaymentPeriod(options.period)
                                    this.props.amountChosen();

                                    trackEvent(
                                        "Valgt pakke m. løbetid",
                                        "Beløb: " + this.props.application.data.loanAmount.valueOf() + "| Mdr.: " + this.props.application.data.repaymentPeriod,
                                        "Valgt beløb og løbetid",
                                        this.props.amountChosen()
                                    )
                                }}
                            >
                                <div className="Package-btn-top">
                                    <span>Betal kun</span>

                                    <div >
                                        <h3>  {
                                            calculateMonthlyPaymentAmount(
                                                this.props.application.data.loanAmount,
                                                options.period
                                            )
                                            } kr./md
                                        </h3>
                                    </div>
                                </div>
                                <div className="Package-btn-bottom">
                                    <span>
                                       Afdragsperiode
                                    </span >
                                <br />
                                    <h5>
                                            {this.monthFormatter(options.period)}
                                    </h5>
                                 </div>
                                  

                              
                            </Button>
                        </Col>
                    ))}
                </div>
       

          {/* > 768px */}
            

          {/* <= 768px */}
                </div>
        </ApplicationContent>
        <ApplicationFooter>
          <Row className="mt-2">
            <Col className="col-12 text-right">
                        <Button className="back" onClick={() => this.props.previous()}>
                              <img src="../images/arrow-left-short.svg" />Tilbage
              </Button>
            </Col>
          </Row>
        </ApplicationFooter>
      </div>
    );
    }

}

const SliderHandle: React.FunctionComponent = () => {
  return <img src="/images/slider-dot.svg" />;
};

const mapStateToProps = (state: RootState) => ({
  application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
  setAmount: (amount: number) => dispatch(setAmount(amount)),
  setRepaymentPeriod: (months: number) => dispatch(setRepaymentPeriod(months)),
    amountChosen: () => dispatch(gotoStep(Step.Contact)),
    previous: () => dispatch(gotoStep(Step.Main))
});



export default connect(mapStateToProps, mapDispatchToProps)(StepTwo);
